import React from "react";
import { Section } from "./Section";

// Add or remove certification objects as needed
const CERTIFICATIONS = [
  { id: 1, name: "cert1.png", alt: "Certification 1" },
  { id: 2, name: "cert2.png", alt: "Certification 2" },
  { id: 3, name: "cert3.png", alt: "Certification 3" },
  { id: 4, name: "cert4.png", alt: "Certification 4" },
];

export const Certifications = () => {
  return (
    <Section id="certifications" className="bg-zinc-950 text-white py-24 lg:py-32">
      <div className="text-center mb-16 reveal-up">
        <div className="text-xs uppercase tracking-[0.22em] text-[#FF4500] font-semibold">
          Excellence & Expertise
        </div>
        <h2
          className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-black tracking-[-0.02em] text-white"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          Certifications Our Team Holds
        </h2>
        <p className="mt-5 text-base sm:text-lg text-zinc-400 max-w-2xl mx-auto leading-relaxed">
          Our team's expertise is validated by industry-leading certifications,
          ensuring you receive world-class service and cutting-edge solutions.
        </p>
      </div>

      {/* Certification Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-6 lg:gap-8 xl:gap-10 items-center reveal-up">
        {CERTIFICATIONS.map((cert) => (
          <div
            key={cert.id}
            className="group relative flex items-center justify-center p-6 bg-zinc-900/40 border border-white/5 rounded-2xl hover:border-[#FF4500]/30 hover:bg-zinc-900/60 transition-all duration-300"
          >
            <div className="relative w-full h-24 flex items-center justify-center">
              <img
                src={`/${cert.name}`}
                alt={cert.alt}
                className="max-w-full max-h-full object-contain transition-all duration-300"
              />
            </div>
            {/* Glow effect on hover */}
            <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-[#FF4500]/0 to-[#FF4500]/0 group-hover:from-[#FF4500]/5 group-hover:to-transparent transition-all duration-300" />
          </div>
        ))}
      </div>

      {/* Trust Badge */}
      <div className="mt-16 text-center reveal-up">
        <div className="inline-flex items-center gap-3 px-6 py-3 bg-zinc-900/60 border border-white/10 rounded-full">
          <svg
            className="w-5 h-5 text-[#FF4500]"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clipRule="evenodd"
            />
          </svg>
          <span className="text-sm text-zinc-300 font-medium">
            Certified professionals committed to excellence
          </span>
        </div>
      </div>
    </Section>
  );
};

export default Certifications;
